import React from 'react'
import Result from "@/pages/Index/Result";
import { Modal } from "antd";
import { HistoryItem } from "@/utils/store/store";
const { confirm } = Modal;

interface Props {}

export const ResultModal = (content:HistoryItem) =>{
    confirm({
      icon: <div></div>,
      // title: '预览',
      width:'590px',
      content: <Result historyItem={content}/>,
      // okText: 'Yes',
      // okType: 'danger',
      footer: null,
      maskClosable: true,
      okButtonProps: {
        disabled: true,
      },
      cancelText: '关闭',
      onOk() {
        console.log('OK');
      },
      onCancel() {
        console.log('Cancel');
      },
    })
}



